export const getPayoutDetails = 'Merchant/GetPayoutDetails';
